module.exports = ".error-401{font-size:2rem;padding-top:10rem}\n"